import React from 'react';
import './form-container.scss';

type Props = {
  classname?: string;
  children: React.ReactNode;
};

export function FormContainer({ classname, children }: Props) {
  return (
    <div className="form-container">
      <div className={`background-container ${classname} || '' `}>
        <div className="columns is-gapless is-centered is-mobile">
          <div className="column is-four-fifths">
            <div className="content-form">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
